import React, { Fragment } from "react";
import SweetAlertBase from "../../../../ui/sweetalert/SweetAlertBase";
import SVG from "react-inlinesvg";
import checkSVG from "../../../../../assets/svg/ils/ils-question.svg";

class SA_SaveEvaluation extends SweetAlertBase {

    config = {
        confirmButtonText: 'Save Evaluation',
        showCancelButton: true,
        cancelButtonText: 'Discard Evaluation',
        reverseButtons: true
    }

    setHtml = (data) => {
        return (
            <Fragment>
                <div className="reject-scouting-alert">
                    <SVG src={checkSVG} />
                    <h2>Save Evaluation</h2>
                    <p>You have not saved or finished the evaluation yet. Shall we save you work? You have to start form beginning if don’t save the evaluation</p>
                </div>
            </Fragment>
        )
    }

    type() {
        return 'sm';
    }

    className() {
        return "save-scouting-modal reject-scouting";
    }

    confirmButtonClasses() {
        return "reject-scouting-done btn btn-primary btn-lg btn-block mb-3";
    }

    cancelButtonClasses() {
        return "reject-scouting-done btn btn-secondary btn-lg btn-block mb-3";
    }
};

export default SA_SaveEvaluation;